import { useRef } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Share2, Copy, Download } from "lucide-react";
import { toast } from "sonner";

export default function SharePreviewDialog({ url, title = "Rider Preview", triggerLabel = "Share", triggerTestId }) {
  const ref = useRef(null);
  const copy = async () => { try { await navigator.clipboard.writeText(url); toast.success("Link copied"); } catch { toast.message("Share link", { description: url }); } };
  const download = () => {
    const canvas = ref.current?.querySelector("canvas");
    if (!canvas) return;
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = `velopaths-preview-${(title || "qr").replace(/\s+/g, "-").toLowerCase()}.png`;
    a.click();
  };
  return (
    <Dialog>
      <DialogTrigger asChild><Button variant="outline" size="sm" data-testid={triggerTestId}><Share2 className="w-4 h-4 mr-1" />{triggerLabel}</Button></DialogTrigger>
      <DialogContent className="max-w-sm" data-testid="share-dialog">
        <DialogHeader><DialogTitle>Share rider preview</DialogTitle><DialogDescription className="truncate">{title}</DialogDescription></DialogHeader>
        <div ref={ref} className="flex justify-center py-3 bg-white rounded-lg" data-testid="share-qr"><QRCodeCanvas value={url} size={200} marginSize={2} /></div>
        <div className="text-xs text-muted-foreground break-all bg-secondary rounded p-2" data-testid="share-url">{url}</div>
        <div className="flex gap-2">
          <Button className="flex-1" variant="outline" onClick={copy} data-testid="share-copy"><Copy className="w-4 h-4 mr-1" />Copy link</Button>
          <Button className="flex-1" onClick={download} data-testid="share-download"><Download className="w-4 h-4 mr-1" />Download QR</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
